import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.InvestmentInstitutionsEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.InvestmentInstitutionsList })));
const create = lazy(() => import("./Create").then(m => ({ default: m.InvestmentInstitutionsCreate })));

export default { edit, list, create };
